
<template>
  <div class="main-content">
    <Container
      :title="t('route.labelFrameCategoryLanguage')"
      :hasLine="true"
    >
      <template #header>
        <SearchForm
          ref="searchFormRef"
          :formModel="searchFormModel"
          :formStruct="searchFormStruct"
          :submitButton="t('common.search')"
          :resetButton="t('common.reset')"
          @submit="submitSearch"
          @reset="resetForm"
        />
      </template>
      <template #main>
        <el-button
          v-if="this.$hasPermission(['ACTION_vcLabelFrameCategoryLanguageEdit'])"
          @click="handleCreate()"
          type="success"
        >
          {{ t('table.add') }}
        </el-button>
        <el-button
          v-if="selection.length > 0 && this.$hasPermission(['ACTION_vcLabelFrameCategoryLanguageEdit'])"
          @click="handleBathDelete()"
          type="danger"
        >
          {{ t('table.bathDelete') }}
        </el-button>
        <SimpleTable
          :isLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :sort="sort"
          :order="order"
          @handleOrder="handleOrder"
          @handleSelection="handleSelection"
        >
          <template
            v-if="this.$hasPermission(['ACTION_vcLabelFrameCategoryLanguageEdit'])"
            #default="slotProps"
          >
            <el-button
              @click="handleEdit(slotProps.row)"
              type="primary"
              size="mini"
            >
              {{ t('common.edit') }}
            </el-button>
            <el-button
              @click="handleDelete(slotProps.row.id)"
              type="danger"
              size="mini"
            >
              {{ t('common.delete') }}
            </el-button>
          </template>
        </SimpleTable>
        <el-pagination
          :total="total"
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          :page-sizes="[5, 10, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;"
        />
      </template>
    </Container>
    <el-dialog
      v-if="this.$hasPermission(['ACTION_vcLabelFrameCategoryLanguageEdit'])"
      :title="t(textMap[dialogStatus])"
      center
      v-model="dialogFormVisible"
      width="45%"
    >
      <NomalContainer>
        <CenterForm
          v-if="dialogStatus === 'create'"
          :formModel="createModel"
          :formStruct="createStruct"
          :formRules="labelFrameCategoryLanguageRole"
          @submit="createSubmit"
          @reset="createReset"
        />
        <CenterForm
          v-if="dialogStatus === 'update'"
          :formModel="updateModel"
          :formStruct="updateStruct"
          :formRules="labelFrameCategoryLanguageRole"
          @submit="updateNameSubmit"
          @reset="updateNameReset"
        />
      </NomalContainer>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import {
  LabelFrameCategoryLanguageModel,
  LabelFrameCategoryLanguagePageSearchModel,
  LabelFrameCategoryLanguageSearchModel,
  LabelFrameCategoryLanguageAddModel,
  LabelFrameCategoryLanguageUpdateModel,
  IdsModel
} from '@/model/product/LabelFrameCategoryLanguageModel'
import {
  pageSearchLabelFrameCategoryLanguage,
  addLabelFrameCategoryLanguage,
  updateLabelFrameCategoryLanguage,
  removeLabelFrameCategoryLanguage,
  batchRemoveLabelFrameCategoryLanguage
} from '@/apis/product/labelFrameCategoryLanguage'
import { LabelFrameCategorySearchModel } from '@/model/product/LabelFrameCategoryModel'
import { searchLabelFrameCategory } from '@/apis/product/labelFrameCategory'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    let categorys: any[] = []
    const searchStruct = [
      {
        prop: 'categoryId',
        label: t('labelFrameCategoryLanguage.category'),
        placeholder: t('labelFrameCategoryLanguage.categoryP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      }
    ]

    const createStruct = [
      {
        prop: 'categoryId',
        label: t('labelFrameCategoryLanguage.category'),
        placeholder: t('labelFrameCategoryLanguage.categoryP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      },
      { prop: 'zhCn', label: t('labelFrameCategoryLanguage.zhCn'), placeholder: t('labelFrameCategoryLanguage.zhCnP'), component: 'el-input', type: 'text', model: null },
      { prop: 'zhTw', label: t('labelFrameCategoryLanguage.zhTw'), placeholder: t('labelFrameCategoryLanguage.zhTwP'), component: 'el-input', type: 'text', model: null },
      { prop: 'en', label: t('labelFrameCategoryLanguage.en'), placeholder: t('labelFrameCategoryLanguage.enP'), component: 'el-input', type: 'text', model: null },
      { prop: 'ja', label: t('labelFrameCategoryLanguage.ja'), placeholder: t('labelFrameCategoryLanguage.jaP'), component: 'el-input', type: 'text', model: null },
      { prop: 'ko', label: t('labelFrameCategoryLanguage.ko'), placeholder: t('labelFrameCategoryLanguage.koP'), component: 'el-input', type: 'text', model: null },
      { prop: 'de', label: t('labelFrameCategoryLanguage.de'), placeholder: t('labelFrameCategoryLanguage.deP'), component: 'el-input', type: 'text', model: null },
      { prop: 'fr', label: t('labelFrameCategoryLanguage.fr'), placeholder: t('labelFrameCategoryLanguage.frP'), component: 'el-input', type: 'text', model: null },
      { prop: 'it', label: t('labelFrameCategoryLanguage.it'), placeholder: t('labelFrameCategoryLanguage.itP'), component: 'el-input', type: 'text', model: null },
      { prop: 'es', label: t('labelFrameCategoryLanguage.es'), placeholder: t('labelFrameCategoryLanguage.esP'), component: 'el-input', type: 'text', model: null },
      { prop: 'ar', label: t('labelFrameCategoryLanguage.ar'), placeholder: t('labelFrameCategoryLanguage.arP'), component: 'el-input', type: 'text', model: null },
      { prop: 'ru', label: t('labelFrameCategoryLanguage.ru'), placeholder: t('labelFrameCategoryLanguage.ruP'), component: 'el-input', type: 'text', model: null },
      { prop: 'nl', label: t('labelFrameCategoryLanguage.nl'), placeholder: t('labelFrameCategoryLanguage.nlP'), component: 'el-input', type: 'text', model: null },
      { prop: 'pt', label: t('labelFrameCategoryLanguage.pt'), placeholder: t('labelFrameCategoryLanguage.ptP'), component: 'el-input', type: 'text', model: null },
      { prop: 'pl', label: t('labelFrameCategoryLanguage.pl'), placeholder: t('labelFrameCategoryLanguage.plP'), component: 'el-input', type: 'text', model: null },
      { prop: 'th', label: t('labelFrameCategoryLanguage.th'), placeholder: t('labelFrameCategoryLanguage.thP'), component: 'el-input', type: 'text', model: null },
      { prop: 'cs', label: t('labelFrameCategoryLanguage.cs'), placeholder: t('labelFrameCategoryLanguage.csP'), component: 'el-input', type: 'text', model: null },
      { prop: 'sk', label: t('labelFrameCategoryLanguage.sk'), placeholder: t('labelFrameCategoryLanguage.skP'), component: 'el-input', type: 'text', model: null },
      { prop: 'el', label: t('labelFrameCategoryLanguage.el'), placeholder: t('labelFrameCategoryLanguage.elP'), component: 'el-input', type: 'text', model: null },
      { prop: 'hu', label: t('labelFrameCategoryLanguage.hu'), placeholder: t('labelFrameCategoryLanguage.huP'), component: 'el-input', type: 'text', model: null },
      { prop: 'bg', label: t('labelFrameCategoryLanguage.bg'), placeholder: t('labelFrameCategoryLanguage.bgP'), component: 'el-input', type: 'text', model: null },
      { prop: 'tr', label: t('labelFrameCategoryLanguage.tr'), placeholder: t('labelFrameCategoryLanguage.trP'), component: 'el-input', type: 'text', model: null },
      { prop: 'ro', label: t('labelFrameCategoryLanguage.ro'), placeholder: t('labelFrameCategoryLanguage.roP'), component: 'el-input', type: 'text', model: null }
    ]

    const updateStruct = [
      {
        prop: 'categoryId',
        label: t('labelFrameCategoryLanguage.category'),
        placeholder: t('labelFrameCategoryLanguage.categoryP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      },
      { prop: 'zhCn', label: t('labelFrameCategoryLanguage.zhCn'), placeholder: t('labelFrameCategoryLanguage.zhCnP'), component: 'el-input', type: 'text', model: null },
      { prop: 'zhTw', label: t('labelFrameCategoryLanguage.zhTw'), placeholder: t('labelFrameCategoryLanguage.zhTwP'), component: 'el-input', type: 'text', model: null },
      { prop: 'en', label: t('labelFrameCategoryLanguage.en'), placeholder: t('labelFrameCategoryLanguage.enP'), component: 'el-input', type: 'text', model: null },
      { prop: 'ja', label: t('labelFrameCategoryLanguage.ja'), placeholder: t('labelFrameCategoryLanguage.jaP'), component: 'el-input', type: 'text', model: null },
      { prop: 'ko', label: t('labelFrameCategoryLanguage.ko'), placeholder: t('labelFrameCategoryLanguage.koP'), component: 'el-input', type: 'text', model: null },
      { prop: 'de', label: t('labelFrameCategoryLanguage.de'), placeholder: t('labelFrameCategoryLanguage.deP'), component: 'el-input', type: 'text', model: null },
      { prop: 'fr', label: t('labelFrameCategoryLanguage.fr'), placeholder: t('labelFrameCategoryLanguage.frP'), component: 'el-input', type: 'text', model: null },
      { prop: 'it', label: t('labelFrameCategoryLanguage.it'), placeholder: t('labelFrameCategoryLanguage.itP'), component: 'el-input', type: 'text', model: null },
      { prop: 'es', label: t('labelFrameCategoryLanguage.es'), placeholder: t('labelFrameCategoryLanguage.esP'), component: 'el-input', type: 'text', model: null },
      { prop: 'ar', label: t('labelFrameCategoryLanguage.ar'), placeholder: t('labelFrameCategoryLanguage.arP'), component: 'el-input', type: 'text', model: null },
      { prop: 'ru', label: t('labelFrameCategoryLanguage.ru'), placeholder: t('labelFrameCategoryLanguage.ruP'), component: 'el-input', type: 'text', model: null },
      { prop: 'nl', label: t('labelFrameCategoryLanguage.nl'), placeholder: t('labelFrameCategoryLanguage.nlP'), component: 'el-input', type: 'text', model: null },
      { prop: 'pt', label: t('labelFrameCategoryLanguage.pt'), placeholder: t('labelFrameCategoryLanguage.ptP'), component: 'el-input', type: 'text', model: null },
      { prop: 'pl', label: t('labelFrameCategoryLanguage.pl'), placeholder: t('labelFrameCategoryLanguage.plP'), component: 'el-input', type: 'text', model: null },
      { prop: 'th', label: t('labelFrameCategoryLanguage.th'), placeholder: t('labelFrameCategoryLanguage.thP'), component: 'el-input', type: 'text', model: null },
      { prop: 'cs', label: t('labelFrameCategoryLanguage.cs'), placeholder: t('labelFrameCategoryLanguage.csP'), component: 'el-input', type: 'text', model: null },
      { prop: 'sk', label: t('labelFrameCategoryLanguage.sk'), placeholder: t('labelFrameCategoryLanguage.skP'), component: 'el-input', type: 'text', model: null },
      { prop: 'el', label: t('labelFrameCategoryLanguage.el'), placeholder: t('labelFrameCategoryLanguage.elP'), component: 'el-input', type: 'text', model: null },
      { prop: 'hu', label: t('labelFrameCategoryLanguage.hu'), placeholder: t('labelFrameCategoryLanguage.huP'), component: 'el-input', type: 'text', model: null },
      { prop: 'bg', label: t('labelFrameCategoryLanguage.bg'), placeholder: t('labelFrameCategoryLanguage.bgP'), component: 'el-input', type: 'text', model: null },
      { prop: 'tr', label: t('labelFrameCategoryLanguage.tr'), placeholder: t('labelFrameCategoryLanguage.trP'), component: 'el-input', type: 'text', model: null },
      { prop: 'ro', label: t('labelFrameCategoryLanguage.ro'), placeholder: t('labelFrameCategoryLanguage.roP'), component: 'el-input', type: 'text', model: null }
    ]

    const labelFrameCategoryLanguageRole = {
      categoryId: [{ required: true, message: t('labelFrameCategoryLanguage.category').concat(t('common.isRequired')), trigger: 'blur' }],
      zhCn: [{ required: true, message: t('labelFrameCategoryLanguage.zhCn').concat(t('common.isRequired')), trigger: 'blur' }],
      zhTw: [{ required: true, message: t('labelFrameCategoryLanguage.zhTw').concat(t('common.isRequired')), trigger: 'blur' }],
      en: [{ required: true, message: t('labelFrameCategoryLanguage.en').concat(t('common.isRequired')), trigger: 'blur' }],
      ja: [{ required: true, message: t('labelFrameCategoryLanguage.ja').concat(t('common.isRequired')), trigger: 'blur' }],
      ko: [{ required: true, message: t('labelFrameCategoryLanguage.ko').concat(t('common.isRequired')), trigger: 'blur' }],
      de: [{ required: true, message: t('labelFrameCategoryLanguage.de').concat(t('common.isRequired')), trigger: 'blur' }],
      fr: [{ required: true, message: t('labelFrameCategoryLanguage.fr').concat(t('common.isRequired')), trigger: 'blur' }],
      it: [{ required: true, message: t('labelFrameCategoryLanguage.it').concat(t('common.isRequired')), trigger: 'blur' }],
      es: [{ required: true, message: t('labelFrameCategoryLanguage.es').concat(t('common.isRequired')), trigger: 'blur' }],
      ar: [{ required: true, message: t('labelFrameCategoryLanguage.ar').concat(t('common.isRequired')), trigger: 'blur' }],
      ru: [{ required: true, message: t('labelFrameCategoryLanguage.ru').concat(t('common.isRequired')), trigger: 'blur' }],
      nl: [{ required: true, message: t('labelFrameCategoryLanguage.nl').concat(t('common.isRequired')), trigger: 'blur' }],
      pt: [{ required: true, message: t('labelFrameCategoryLanguage.pt').concat(t('common.isRequired')), trigger: 'blur' }],
      pl: [{ required: true, message: t('labelFrameCategoryLanguage.pl').concat(t('common.isRequired')), trigger: 'blur' }],
      th: [{ required: true, message: t('labelFrameCategoryLanguage.th').concat(t('common.isRequired')), trigger: 'blur' }],
      cs: [{ required: true, message: t('labelFrameCategoryLanguage.cs').concat(t('common.isRequired')), trigger: 'blur' }],
      sk: [{ required: true, message: t('labelFrameCategoryLanguage.sk').concat(t('common.isRequired')), trigger: 'blur' }],
      el: [{ required: true, message: t('labelFrameCategoryLanguage.el').concat(t('common.isRequired')), trigger: 'blur' }],
      hu: [{ required: true, message: t('labelFrameCategoryLanguage.hu').concat(t('common.isRequired')), trigger: 'blur' }],
      bg: [{ required: true, message: t('labelFrameCategoryLanguage.bg').concat(t('common.isRequired')), trigger: 'blur' }],
      tr: [{ required: true, message: t('labelFrameCategoryLanguage.tr').concat(t('common.isRequired')), trigger: 'blur' }],
      ro: [{ required: true, message: t('labelFrameCategoryLanguage.ro').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'categoryId', label: t('labelFrameCategoryLanguage.categoryId'), sortable: 'custom' },
      { prop: 'categoryId', label: t('labelFrameCategoryLanguage.category'), formatter: (row: LabelFrameCategoryLanguageModel) => { return categorys.find(c => c.value === row.categoryId)?.label }, sortable: 'custom' },
      { prop: 'zhCn', label: t('labelFrameCategoryLanguage.zhCn'), sortable: 'custom' },
      { prop: 'zhTw', label: t('labelFrameCategoryLanguage.zhTw'), sortable: 'custom' },
      { prop: 'en', label: t('labelFrameCategoryLanguage.en'), sortable: 'custom' },
      { prop: 'ja', label: t('labelFrameCategoryLanguage.ja'), sortable: 'custom' },
      { prop: 'ko', label: t('labelFrameCategoryLanguage.ko'), sortable: 'custom' },
      { prop: 'de', label: t('labelFrameCategoryLanguage.de'), sortable: 'custom' },
      { prop: 'fr', label: t('labelFrameCategoryLanguage.fr'), sortable: 'custom' },
      { prop: 'it', label: t('labelFrameCategoryLanguage.it'), sortable: 'custom' },
      { prop: 'es', label: t('labelFrameCategoryLanguage.es'), sortable: 'custom' },
      { prop: 'ar', label: t('labelFrameCategoryLanguage.ar'), sortable: 'custom' },
      { prop: 'ru', label: t('labelFrameCategoryLanguage.ru'), sortable: 'custom' },
      { prop: 'nl', label: t('labelFrameCategoryLanguage.nl'), sortable: 'custom' },
      { prop: 'pt', label: t('labelFrameCategoryLanguage.pt'), sortable: 'custom' },
      { prop: 'pl', label: t('labelFrameCategoryLanguage.pl'), sortable: 'custom' },
      { prop: 'th', label: t('labelFrameCategoryLanguage.th'), sortable: 'custom' },
      { prop: 'cs', label: t('labelFrameCategoryLanguage.cs'), sortable: 'custom' },
      { prop: 'sk', label: t('labelFrameCategoryLanguage.sk'), sortable: 'custom' },
      { prop: 'el', label: t('labelFrameCategoryLanguage.el'), sortable: 'custom' },
      { prop: 'hu', label: t('labelFrameCategoryLanguage.hu'), sortable: 'custom' },
      { prop: 'bg', label: t('labelFrameCategoryLanguage.bg'), sortable: 'custom' },
      { prop: 'tr', label: t('labelFrameCategoryLanguage.tr'), sortable: 'custom' },
      { prop: 'ro', label: t('labelFrameCategoryLanguage.ro'), sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: LabelFrameCategoryLanguageModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: LabelFrameCategoryLanguageModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as LabelFrameCategoryLanguageSearchModel,
      tableData: Array<LabelFrameCategoryLanguageModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'labelFrameCategoryLanguage.edit',
        create: 'labelFrameCategoryLanguage.create'
      },
      dialogFormVisible: false,
      labelFrameCategoryLanguageRole: labelFrameCategoryLanguageRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as LabelFrameCategoryLanguageAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as LabelFrameCategoryLanguageUpdateModel,
      editRow: {} as LabelFrameCategoryLanguageModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: LabelFrameCategoryLanguagePageSearchModel = {
          categoryId: dataMap.searchFormModel.categoryId,
          zhCn: dataMap.searchFormModel.zhCn,
          zhTw: dataMap.searchFormModel.zhTw,
          en: dataMap.searchFormModel.en,
          ja: dataMap.searchFormModel.ja,
          ko: dataMap.searchFormModel.ko,
          de: dataMap.searchFormModel.de,
          fr: dataMap.searchFormModel.fr,
          it: dataMap.searchFormModel.it,
          es: dataMap.searchFormModel.es,
          ar: dataMap.searchFormModel.ar,
          ru: dataMap.searchFormModel.ru,
          nl: dataMap.searchFormModel.nl,
          pt: dataMap.searchFormModel.pt,
          pl: dataMap.searchFormModel.pl,
          th: dataMap.searchFormModel.th,
          cs: dataMap.searchFormModel.cs,
          sk: dataMap.searchFormModel.sk,
          el: dataMap.searchFormModel.el,
          hu: dataMap.searchFormModel.hu,
          bg: dataMap.searchFormModel.bg,
          tr: dataMap.searchFormModel.tr,
          ro: dataMap.searchFormModel.ro,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchLabelFrameCategoryLanguage(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        const createData: LabelFrameCategoryLanguageAddModel = {
          categoryId: dataMap.createModel.categoryId,
          zhCn: dataMap.createModel.zhCn,
          zhTw: dataMap.createModel.zhTw,
          en: dataMap.createModel.en,
          ja: dataMap.createModel.ja,
          ko: dataMap.createModel.ko,
          de: dataMap.createModel.de,
          fr: dataMap.createModel.fr,
          it: dataMap.createModel.it,
          es: dataMap.createModel.es,
          ar: dataMap.createModel.ar,
          ru: dataMap.createModel.ru,
          nl: dataMap.createModel.nl,
          pt: dataMap.createModel.pt,
          pl: dataMap.createModel.pl,
          th: dataMap.createModel.th,
          cs: dataMap.createModel.cs,
          sk: dataMap.createModel.sk,
          el: dataMap.createModel.el,
          hu: dataMap.createModel.hu,
          bg: dataMap.createModel.bg,
          tr: dataMap.createModel.tr,
          ro: dataMap.createModel.ro
        }
        const result = await addLabelFrameCategoryLanguage(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: LabelFrameCategoryLanguageUpdateModel = {
          id: dataMap.updateModel.id,
          categoryId: dataMap.updateModel.categoryId,
          zhCn: dataMap.updateModel.zhCn,
          zhTw: dataMap.updateModel.zhTw,
          en: dataMap.updateModel.en,
          ja: dataMap.updateModel.ja,
          ko: dataMap.updateModel.ko,
          de: dataMap.updateModel.de,
          fr: dataMap.updateModel.fr,
          it: dataMap.updateModel.it,
          es: dataMap.updateModel.es,
          ar: dataMap.updateModel.ar,
          ru: dataMap.updateModel.ru,
          nl: dataMap.updateModel.nl,
          pt: dataMap.updateModel.pt,
          pl: dataMap.updateModel.pl,
          th: dataMap.updateModel.th,
          cs: dataMap.updateModel.cs,
          sk: dataMap.updateModel.sk,
          el: dataMap.updateModel.el,
          hu: dataMap.updateModel.hu,
          bg: dataMap.updateModel.bg,
          tr: dataMap.updateModel.tr,
          ro: dataMap.updateModel.ro
        }
        const result = await updateLabelFrameCategoryLanguage(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeLabelFrameCategoryLanguage(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveLabelFrameCategoryLanguage(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.categoryId = dataMap.editRow.categoryId
        dataMap.updateModel.zhCn = dataMap.editRow.zhCn
        dataMap.updateModel.zhTw = dataMap.editRow.zhTw
        dataMap.updateModel.en = dataMap.editRow.en
        dataMap.updateModel.ja = dataMap.editRow.ja
        dataMap.updateModel.ko = dataMap.editRow.ko
        dataMap.updateModel.de = dataMap.editRow.de
        dataMap.updateModel.fr = dataMap.editRow.fr
        dataMap.updateModel.it = dataMap.editRow.it
        dataMap.updateModel.es = dataMap.editRow.es
        dataMap.updateModel.ar = dataMap.editRow.ar
        dataMap.updateModel.ru = dataMap.editRow.ru
        dataMap.updateModel.nl = dataMap.editRow.nl
        dataMap.updateModel.pt = dataMap.editRow.pt
        dataMap.updateModel.pl = dataMap.editRow.pl
        dataMap.updateModel.th = dataMap.editRow.th
        dataMap.updateModel.cs = dataMap.editRow.cs
        dataMap.updateModel.sk = dataMap.editRow.sk
        dataMap.updateModel.el = dataMap.editRow.el
        dataMap.updateModel.hu = dataMap.editRow.hu
        dataMap.updateModel.bg = dataMap.editRow.bg
        dataMap.updateModel.tr = dataMap.editRow.tr
        dataMap.updateModel.ro = dataMap.editRow.ro
      },
      createReset() {
        console.log('create reset')
      }
    })
    const getLabelFrameCategoryOptions = async(query: string) => {
      if (dataMap.dialogFormVisible) {
        if (dataMap.dialogStatus === 'create') {
          dataMap.createStruct[0].loading = true
        } else if (dataMap.dialogStatus === 'update') {
          dataMap.updateStruct[0].loading = true
        }
      } else {
        dataMap.searchFormStruct[0].loading = true
      }
      const params: LabelFrameCategorySearchModel = {
        categoryName: query,
        categoryOrder: null
      }
      const data = await searchLabelFrameCategory(params)
      const list = data?.data ?? []
      const optionList = []
      for (const iterator of list) {
        optionList.push({ label: iterator.categoryName, value: iterator.id })
      }
      categorys = optionList
      if (dataMap.dialogFormVisible) {
        if (dataMap.dialogStatus === 'create') {
          dataMap.createStruct[0].options = optionList
        } else if (dataMap.dialogStatus === 'update') {
          dataMap.updateStruct[0].options = optionList
        }
      } else {
        dataMap.searchFormStruct[0].options = optionList
      }
      dataMap.createStruct[0].loading = false
      dataMap.updateStruct[0].loading = false
      dataMap.searchFormStruct[0].loading = false
    }
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      getLabelFrameCategoryOptions('')
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: LabelFrameCategoryLanguageModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.categoryId = row.categoryId
        dataMap.updateModel.zhCn = row.zhCn
        dataMap.updateModel.zhTw = row.zhTw
        dataMap.updateModel.en = row.en
        dataMap.updateModel.ja = row.ja
        dataMap.updateModel.ko = row.ko
        dataMap.updateModel.de = row.de
        dataMap.updateModel.fr = row.fr
        dataMap.updateModel.it = row.it
        dataMap.updateModel.es = row.es
        dataMap.updateModel.ar = row.ar
        dataMap.updateModel.ru = row.ru
        dataMap.updateModel.nl = row.nl
        dataMap.updateModel.pt = row.pt
        dataMap.updateModel.pl = row.pl
        dataMap.updateModel.th = row.th
        dataMap.updateModel.cs = row.cs
        dataMap.updateModel.sk = row.sk
        dataMap.updateModel.el = row.el
        dataMap.updateModel.hu = row.hu
        dataMap.updateModel.bg = row.bg
        dataMap.updateModel.tr = row.tr
        dataMap.updateModel.ro = row.ro
        getLabelFrameCategoryOptions('')
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    onMounted(() => {
      dataMap.searchFormStruct[0].remoteMethod = getLabelFrameCategoryOptions
      dataMap.createStruct[0].remoteMethod = getLabelFrameCategoryOptions
      dataMap.updateStruct[0].remoteMethod = getLabelFrameCategoryOptions
      getLabelFrameCategoryOptions('')
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      ...toRefs(dataMap)
    }
  }
})
</script>
